<div class="raw-content-page-layout">
  <oth-hero [contents]="[{ text: 'Blog', level: 1 }]"></oth-hero>
  <div class="flexible-cards-wrapper">
    <ng-container *ngFor="let blog of BLOG">
      <app-blog-holder-card (click)="openBlog(blog.tag, blog.key)" [blog]="blog"
                            class="blog-holder-card"></app-blog-holder-card>
    </ng-container>
  </div>
</div>
